import React from "react";

export const PostOHRContext = React.createContext(null);

export const PostOHRProvider = ({ children, value }) => {
  const [postOHR, setPostOHR] = React.useState(value);
  return (
    <PostOHRContext.Provider value={{ postOHR, setPostOHR }}>
      {children}
    </PostOHRContext.Provider>
  );
};

export const usePostOHR = () => {
  const context = React.useContext(PostOHRContext);
  if (context === null) {
    throw new Error("usePostOHR must be used within a PostOHRProvider");
  }
  return context;
};
